Aquí tienes el código **completo**, manteniendo la altura original (`top: 125px`) para que no quede muy arriba, pero conservando la escala reducida del texto en celulares para que no se vea desproporcionado:

```vue
<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">

        <!-- Nombre en la esquina superior derecha (Posición controlable) -->
        <div
          ref="nombreRef"
          class="centered-text"
        >
          <span ref="alexaRef" class="nombre-linea alexa-text">Alexa</span>
          <span ref="ontiverosRef" class="nombre-linea ontiveros-text">Ontiveros</span>

          <!-- Corona + MIS XV colocados abajo del texto -->
          <div ref="misXvWrapperRef" class="mis-xv-below">
            <img
              src="@/assets/corona.png"
              alt="Ornamento"
              class="ornamento-img"
            >
            <div
              ref="misXvTopRef"
              class="mis-xv-top glowing"
            >
              MIS XV
            </div>
          </div>

          <!-- Fecha del evento -->
          <div
            ref="fechaRef"
            class="fecha-evento"
          >
            <span class="fecha-dia">24</span>
            <span class="fecha-separador">•</span>
            <span class="fecha-mes">OCT</span>
            <span class="fecha-separador">•</span>
            <span class="fecha-anio">2026</span>
          </div>
        </div>

      </div>

      <!-- Fina línea dorada/brillante en el borde inferior -->
      <div class="linea-borde-discreta"></div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const nombreRef = ref(null)
    const alexaRef = ref(null)
    const ontiverosRef = ref(null)
    const fechaRef = ref(null)
    const misXvTopRef = ref(null)
    const misXvWrapperRef = ref(null)

    onMounted(() => {
      ScrollTrigger.refresh()

      // Timeline principal para sincronizar animaciones ágiles
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: fotoPortadaRef.value,
          start: 'top top',
          once: true
        }
      })

      // 0. Revelado sutil del fondo
      tl.fromTo(
        fotoPortadaRef.value,
        { opacity: 0, scale: 1.05, filter: 'blur(6px)' },
        { opacity: 1, scale: 1, filter: 'blur(0px)', duration: 1, ease: 'power2.out' }
      )

      // 1. "Alexa" cae desde arriba
      .fromTo(
        alexaRef.value,
        { opacity: 0, y: -60, filter: 'blur(8px)' },
        { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7, ease: 'back.out(1.4)' },
        '-=0.6'
      )

      // 2. "Ontiveros" sube desde abajo
      .fromTo(
        ontiverosRef.value,
        { opacity: 0, y: 60, filter: 'blur(8px)' },
        { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7, ease: 'back.out(1.4)' },
        '-=0.5'
      )

      // 3. Aparece la corona y "MIS XV" con efecto de escala desde el centro
      .fromTo(
        misXvWrapperRef.value,
        { opacity: 0, scale: 0.5, y: 15 },
        { opacity: 1, scale: 1, y: 0, duration: 0.6, ease: 'back.out(1.8)' },
        '-=0.3'
      )

      // 4. Aparición suave y rápida de la fecha
      .fromTo(
        fechaRef.value.children,
        { opacity: 0, y: 15 },
        { opacity: 1, y: 0, duration: 0.4, stagger: 0.08, ease: 'power2.out' },
        '-=0.2'
      )
    })

    return {
      fotoPortadaRef,
      nombreRef,
      alexaRef,
      ontiverosRef,
      fechaRef,
      misXvTopRef,
      misXvWrapperRef
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* ================= CONTENEDOR FOTO ================= */
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  margin-top: -65px;
  background-image:
    linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.3) 100%),
    url('@/assets/final-2 (1)_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;

  /* ✨ DIFUMINADO ELEGANTE, SUAVE Y MODERNO */
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(0,0,0,1) 0%,
    rgba(0,0,0,1) 75%,
    rgba(0,0,0,0.6) 88%,
    rgba(0,0,0,0) 100%
  );
  mask-image: linear-gradient(
    to bottom,
    rgba(0,0,0,1) 0%,
    rgba(0,0,0,1) 75%,
    rgba(0,0,0,0.6) 88%,
    rgba(0,0,0,0) 100%
  );

  box-shadow:
    0 -40px 80px rgba(255,255,255,0.08) inset,
    0 20px 30px rgba(0,0,0,0.25);
}

/* ================= OVERLAY ================= */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  z-index: 2;
}

/* ================= NOMBRE (POSICIONADO A LA DERECHA) ================= */
.centered-text {
  position: absolute;
  
  /* 📍 Mantiene la altura deseada en todos los dispositivos */
  top: 125px !important;
  right: 30px;
  left: auto;
  
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.nombre-linea {
  display: block;
 font-family: 'CynthiaJuneJF', serif;
   font-size: clamp(72px, 12vw, 95px) !important;
  font-weight: 400;
  margin-top:-20px;
  line-height: 1.1;
  color: #ffffff;
  text-shadow: 0 9px 19px rgba(0,0,0,0.4);
  white-space: nowrap;
  will-change: transform, opacity;
}

.alexa-text {
  margin-bottom: 2px;
}

.ontiveros-text {
  margin-bottom: 12px;
}

/* ================= MIS XV ABAJO DEL TEXTO ================= */
.mis-xv-below {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 6px;
  margin-bottom: 8px;
  will-change: transform, opacity;
}

.ornamento-img {
  width: 36px;
  height: auto;
  filter: brightness(0) invert(1) drop-shadow(0 2px 4px rgba(0,0,0,0.3));
  margin-bottom: 2px;
}

.mis-xv-top {
  font-family: 'file', sans-serif;
  font-size: 18px;
  letter-spacing: 2px;
  color: white;
}

.glowing {
  animation: glow 2.5s ease-in-out infinite alternate;
}

@keyframes glow {
  from { text-shadow: 0 0 4px rgba(255,255,255,0.3); }
  to   { text-shadow: 0 0 14px rgba(255,255,255,0.9); }
}

/* ================= FECHA ================= */
.fecha-evento {
  font-family: 'Karla', sans-serif;
  color: white;
  font-size: 16px;
  letter-spacing: 2px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

/* ================= DETALLE DISCRETO INFERIOR ================= */
.linea-borde-discreta {
  position: absolute;
  bottom: 0;
  left: 10%;
  width: 80%;
  height: 1px;
  pointer-events: none;
  z-index: 4;
  background: linear-gradient(
    90deg, 
    transparent 0%, 
    rgba(255, 235, 180, 0.5) 50%, 
    transparent 100%
  );
  box-shadow: 0 0 8px rgba(255, 220, 150, 0.4);
}

/* Adaptación de tamaño en móviles conservando la misma altura (top: 125px) */
@media (max-width: 600px) {
  .centered-text {
    right: 15px;
  }
  
  .nombre-linea {
    font-size: clamp(38px, 11vw, 52px);
  }

  .ornamento-img {
    width: 28px;
  }

  .mis-xv-top {
    font-size: 18px;
    letter-spacing: 1.5px;
  }

  .fecha-evento {
    font-size: 18px;
    gap: 4px;
  }
}

/* Adaptación para celulares muy pequeños */
@media (max-width: 380px) {
  .centered-text {
    right: 10px;
  }

  .nombre-linea {
    font-size: 36px;
  }

  .ornamento-img {
    width: 24px;
  }

  .mis-xv-top {
    font-size: 12px;
  }

  .fecha-evento {
    font-size: 11px;
  }
}
</style>

```